<div class="container p-0 min-w-[28rem]">
  <mat-dialog-content class="text-black text-base">
    <h1 class="text-center font-medium ">Complete Your Settings</h1>
    <div class="pl-20 pr-20 pt-10 pd-10">
    <app-signature-settings
      content
      [formGroup]="formGroup"
      [settingsConfiguration]="settingsConfiguration"
    ></app-signature-settings>
    </div>
    <div class="flex justify-center mt-3">
      <thera-button [config]="buttonConfig" (clicked)="onSave()" [disabled]="saveDisable"> </thera-button>
    </div>
  </mat-dialog-content>
</div>
